<template lang="pug">
#app.questionnaire-form
	.step
		h1 {{ questionText }}
		div(:is="stepComponent", :question="currentQuestion")
	.debug
		.actions
			bunt-button(@click="$store.dispatch('reset')") reset
			bunt-link-button(:to="{name: 'designer'}") designer
		.state {{ stringedAnswers }}
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import answerTypes from './answer-types'
export default {
	name: 'QuestionnaireForm',
	components: {},
	data () {
		return {
		}
	},
	computed: {
		...mapState(['answers']),
		...mapGetters(['currentQuestion']),
		questionText () {
			if (this.currentQuestion.question.function) {
				return new Function('answers', this.question.question.function)(this.answers)
			}
			return this.currentQuestion.question
		},
		stepComponent () {
			return answerTypes[this.currentQuestion.answer.type]
		},
		stringedAnswers () {
			return JSON.stringify(this.answers, null, 2)
		}
	},
	created () {
	},
	mounted () {
		this.$nextTick(() => {
		})
	},
	methods: {}
}
</script>
<style lang="stylus">
@import '~settings'
.questionnaire-form
	display: flex
	.step
		flex: auto
		display: flex
		flex-direction: column
		align-items: center
		padding: 20vh 0
		h1
			font-weight: 300
			font-size: 48px

		.btn-next
			button-style(color: $clr-primary, size: 'large')
	.debug
		card()
		width: 420px
		display: flex
		flex-direction: column
		.state
			padding: 8px
			white-space: pre
</style>
